import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import PreviewPage from '../pages/layout-builder/Preview'
import OutpatientPageWrapper from '../pages/layout-outpatient/OutpatientPageWrapper'
import PatientPageWrapper from '../pages/layout-outpatient/PatientPageWrapper'
import InpatientPageWrapper from '../pages/layout-inpatient/InpatientPageWrapper'
import SettlementPageWrapper from '../pages/layout-settlement/SettlementPageWrapper'
import SettlementDetailPageWrapper from '../pages/layout-settlement/tab-components/SettlementDetailPageWrapper'
import NotificationPage from '../pages/notification/NotificationPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../pages/account/AccountPage'))
  const ManualActivationPage = lazy(() => import('../pages/manual-activation/ManualActivationPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const DailyMonitoring = lazy(
    () => import('../../app/pages/layout-settlement/tab-components/DailyMonitoring')
  )

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='preview' element={<PreviewPage />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='outpatient' element={<OutpatientPageWrapper />} />
        <Route path='patient' element={<PatientPageWrapper />} />
        <Route path='inpatient' element={<InpatientPageWrapper />} />
        <Route path='settlement' element={<SettlementPageWrapper />} />
        <Route path='settlement-detail' element={<SettlementDetailPageWrapper />} />
        <Route path='notifications' element={<NotificationPage />} />
        <Route
          path='account'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='manual-activation'
          element={
            <SuspensedView>
              <ManualActivationPage />
            </SuspensedView>
          }
        />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
